import { VStack, Header, Paragraph, Box } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';
import { SearchField } from '@vimeo/ui/core/search';

export interface Props {
  error: Error;
}

export const ErrorContent = ({ error }: Props) => (
  <VStack textAlign="center">
    <Header size={{ base: 'lg', md: '2xl' }}>
      {translate("Sorry, we couldn't find that page")}
    </Header>
    <Paragraph size={{ base: 'md', md: 'lg' }}>
      {translate('Make sure you’ve typed the URL correctly, or try searching Vimeo.')}
    </Paragraph>
    <Box mt={100} w={{ base: '75%', md: '448px' }}>
      <SearchField />
    </Box>
  </VStack>
);
